<template>
  <div class="accordion" :class="getAccordionClasses">
    <header
      v-if="onClickSelf"
      @click.self="!isDisabled && $emit('toggleAccordion')"
    >
      <slot name="header"></slot>
    </header>
    <header class="header" @click="$emit('toggleAccordion')" v-else>
      <slot name="header"></slot>
    </header>

    <header class="header-actions">
      <slot name="headerActions"></slot>
    </header>
    <main>
      <slot name="body"></slot>
    </main>
    <footer>
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    isOpen: { type: Boolean, default: false },
    onClickSelf: { type: Boolean, default: false },
    isBorderless: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    isSquared: { type: Boolean, default: false },
    hasShadow: { type: Boolean, default: true },
    highlight: { type: Boolean, default: false }
  },
  computed: {
    getAccordionClasses() {
      return `${this.isOpen ? "open" : ""} ${
        this.isBorderless ? "borderless" : ""
      } ${this.isDisabled ? "disabled" : ""} ${
        this.isSquared ? "is-squared" : ""
      } ${this.hasShadow ? "has-shadow" : ""} ${
        this.highlight ? "highlight" : ""
      }`;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 10px;
  min-height: 45px;
  cursor: pointer;
  position: relative;
  
  &.header-actions {
    min-height: 0;
  }
}
main {
  max-height: 0;
  transform: scaleY(0);
  opacity: 0;
  transform-origin: bottom;
  transition: opacity 0.5s, max-height 0.25s ease;
  &.from-bottom {
    transform-origin: bottom;
  }
}
.disabled header {
  cursor: default !important;
}
.borderless > header {
  padding: 0;
  border-radius: 0;
  // padding-top: 5px;
}
.borderless > main {
  margin: 10px 0 5px;
}
.accordion.is-squared {
  border-radius: 0;
  padding: 4px 0 8px 0;
  &:not(:last-child) {
    border-bottom: var(--border);
    box-shadow: none;
  }
}
.borderless > header .icon {
  padding-right: 5px;
}
.borderless.open > header {
  border-bottom: var(--border);
}

.accordion {
  border-radius: 8px;
  background-color: #fff;
  width: 100%;
  &.has-shadow {
    box-shadow: var(--box-shadow);
  }
}

.highlight {
  // font-weight: bold;
  // background-color: aliceblue;
}

.disabled .arrow {
  display: none;
}

.accordion.open > main {
  max-height: 650px;
  opacity: 1;
  transition: opacity 0.5s ease, max-height 0.25s ease;
  transform: scaleY(1);
}

.borderless {
  border: 0;
  box-shadow: none;
}
</style>
